import { IEnvironment } from '../models';
import { environment } from './environment';

export const environmentSbx: IEnvironment = {
  ...environment,
  envName: 'sandbox',
  chatbotApiUrl: 'https://immomio-ida.meho.ai',
  production: true,
};
